(function () {
    'use strict';

    angular.module("product")
        .controller('ProductOptionsGroupOptionsAddModalController', ProductOptionsGroupOptionsAddModalController);

    ProductOptionsGroupOptionsAddModalController.$inject = ['group_option', 'options', '$uibModalInstance'];

    function ProductOptionsGroupOptionsAddModalController(group_option, options, $uibModalInstance) {
        var self = this;

        self.selectedOptions = {
            group_option: group_option,
            option_pks: [],
        };

        self.options = options;

        self.ok = ok;

        function ok() {
            self.selectedOptions.options = self.options.filter(function(item) {
                return self.selectedOptions.option_pks.indexOf(item.pk) !== -1;
            });
            $uibModalInstance.close(self.selectedOptions);
        }
    }
})();
